import { useState, useEffect } from 'react';

export function getBreakPoint(windowWidth) {
    if (!windowWidth) return undefined;
    let deviceType = 'XL';
    if (windowWidth < 768) {
        deviceType = 'S';
    } else if (windowWidth < 1280) {
        deviceType = 'M';
    }
    return deviceType;
}

export const deviceMap = {
    XL: 'isDesktop',
    S: 'isMobile',
    M: 'isTablet',
};

export function useWindowSize() {
    const isWindowClient = typeof window === 'object';

    const [windowSize, setWindowSize] = useState(
        isWindowClient ? getBreakPoint(window.innerWidth) : undefined
    );

    useEffect(() => {
        function setSize() {
            setWindowSize(getBreakPoint(window.innerWidth));
        }

        if (isWindowClient) {
            window.addEventListener('load', setSize);
            window.addEventListener('resize', setSize);
            return () => window.removeEventListener('load resize', setSize);
        }
    }, [isWindowClient, setWindowSize]);

    return windowSize;
}
